export default function RecentJobsSkeleton() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" role="status" aria-label="Loading recently posted jobs">
      {Array.from({ length: 6 }, (_, index) => (
        <div key={index} className="recent-job-card min-h-[260px] animate-pulse p-5">
          <div className="flex items-center gap-3">
            <span className="h-10 w-10 rounded-md bg-muted" />
            <span className="space-y-2">
              <span className="block h-3 w-28 rounded bg-muted" />
              <span className="block h-2.5 w-20 rounded bg-muted" />
            </span>
          </div>
          <span className="mt-6 block h-4 w-5/6 rounded bg-muted" />
          <span className="mt-2 block h-4 w-2/3 rounded bg-muted" />
          <div className="mt-5 grid grid-cols-2 gap-3">
            <span className="h-3 rounded bg-muted" />
            <span className="h-3 rounded bg-muted" />
            <span className="h-3 w-4/5 rounded bg-muted" />
          </div>
          <span className="mt-8 block h-px bg-muted" />
        </div>
      ))}
    </div>
  );
}
